function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Lesson-download-icon",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_543",
  transform: "translate(14.000000, 7.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_542",
  transform: "translate(0.152000, 0.954000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.315,9.461 C34.622,6.93 39.252,3.944 47.649,2.696 C48.157934,3.41907836 48.7159127,4.10636112 49.319,4.753 C49.319,4.753 45.223,3.817 28.315,9.461 Z M44.334,1.689 L42.958,0 C35.925,2.047 32.502,5.167 27.536,8.085 C41.076,1.246 44.334,1.689 44.334,1.689 L44.334,1.689 Z M30.457,39.382 C36.8717347,37.3116099 43.5088397,36.0072155 50.23,35.496 L50.23,6.683 C43.5088385,7.19420619 36.8717324,8.49860079 30.457,10.569 L30.457,39.382 Z",
  id: "Path_771"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.911,4.752 C1.51354958,4.10516013 2.07118247,3.41789179 2.58,2.695 C10.98,3.943 15.608,6.929 21.914,9.46 C5.007,3.817 0.911,4.752 0.911,4.752 Z M22.693,8.085 C17.727,5.166 14.305,2.046 7.271,0 L5.895,1.689 C5.895,1.689 9.148,1.246 22.693,8.085 Z M19.772,10.568 C13.3575267,8.49792298 6.72079005,7.19353504 0,6.682 L0,35.496 C6.72083169,36.0072285 13.3576041,37.3116235 19.772,39.382 L19.772,10.568 Z",
  id: "Path_772"
})), /*#__PURE__*/React.createElement("path", {
  d: "M29.269,42.492 L29.269,12.31 C29.2685374,12.124399 29.2531545,11.9391356 29.223,11.756 C26.6537702,12.605738 23.8792298,12.605738 21.31,11.756 C21.2795079,11.9390937 21.2641227,12.1243847 21.264,12.31 L21.264,42.492 L16.416,42.492 L25.266,54.386 L34.116,42.492 L29.269,42.492 Z",
  id: "Path_773",
  fill: "#EEDC98"
})));
function SvgLessonDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "69px",
    viewBox: "0 0 80 69",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Lesson-download-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonDownloadIcon);
export default __webpack_public_path__ + "static/media/Lesson-download-icon.6faa6b45f16d4551eef70d2809ae105b.svg";
export { ForwardRef as ReactComponent };